import { MaterialIcon } from "ui-widgets";
import React from "react";

const ArrowAnimation = ({
  isOpen,
  style,
}: {
  isOpen: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <MaterialIcon
      style={{
        transform: isOpen ? "rotate(180deg)" : "rotate(360deg)",
        transitionDuration: "0.3s",
        ...style,
      }}
      icon="expand_less"
    />
  );
};

export default ArrowAnimation;
